"use strict";
exports.__esModule = true;
exports.LIABILITY_ACCOUNTS = void 0;
var LIABILITY_ACCOUNTS = {
    PERSONAL_LOAN: 'personalLoan',
    CREDIT_CARD: 'creditCard',
    HOME_LOAN: 'homeLoan',
    LOAN: 'loan',
    OTHER_CREDIT: 'otherCredit'
};
exports.LIABILITY_ACCOUNTS = LIABILITY_ACCOUNTS;
